export const getImage = (imgName: string) => {
  return `${`assets/${
    process.env.REACT_APP_AFFILIATE_NAME || 'default'
  }/images/${imgName}`}`
}

export const getImageByUrl = (imgName: string) => {
  return `url(${`assets/${
    process.env.REACT_APP_AFFILIATE_NAME || 'default'
  }/images/${imgName}`})`
}
